module.exports = __webpack_public_path__ + "img/fattureincloud.556856f4.jpg";